<script lang="ts">
	import type AuthProvider from '$lib/components/auth/store.svelte';

	import { goto } from '$app/navigation';
	import { m } from '$lib/paraglide/messages';
	import { getContext } from 'svelte';

	const auth = getContext<AuthProvider>('auth');

	let open = false;

	const toggleMenu = () => {
		if (!auth.isAuthenticated) {
			goto('/customer/account/login?redirect=/customer/order');
		}
		open = !open;
	};

	function outside(node: HTMLElement) {
		const handle = (e: MouseEvent) => {
			if (open && !node.contains(e.target as Node)) {
				open = false;
			}
		};
		document.addEventListener('mousedown', handle);
		return {
			destroy() {
				document.removeEventListener('mousedown', handle);
			},
		};
	}
</script>

<button class="relative cursor-pointer" onclick={toggleMenu} use:outside>
	<div class="icon-[mdi--user] block size-full"></div>
	{#if auth.isAuthenticated}
		<span
			class="absolute top-0 right-0 flex size-1/2 items-center justify-center rounded-full bg-green-500 text-white"
		>
			<span class="icon-[mdi--check] size-3"></span>
		</span>
	{/if}

	{#if open && auth.isAuthenticated}
		<div
			class="fixed inset-x-3 top-14 z-100 mt-10 mr-8 ml-8 cursor-auto rounded border
				border-gray-300 bg-white
            	shadow-xl md:absolute md:inset-auto md:top-full md:-right-0 md:mt-2 md:mr-auto md:w-72"
		>
			<div class="absolute -top-3 -right-0 -translate-x-1/2">
				<svg width="20" height="12">
					<path d="M0 12 L10 0 L20 12" fill="white" stroke="#D1D5DB" />
				</svg>
			</div>
			<div class="mt-4 mb-4 flex justify-center">
				<div
					class="flex size-14 items-center justify-center rounded-full bg-neutral-300 text-neutral-500"
				>
					<span class="icon-[mdi--account] size-8"></span>
				</div>
			</div>

			<ul class="border-t border-gray-200">
				<li class="hover:bg-neutral-200">
					<a href="/customer/order" class="flex items-center px-5 py-4">
						<span class="icon-[mdi--package-variant-closed] mr-2" aria-hidden="true"></span>
						{m.my_orders()}
					</a>
				</li>
				<li class="hover:bg-neutral-200">
					<a
						href="/"
						onclick={() => {
							open = false;
							auth.logout();
						}}
						class="flex items-center px-5 py-4"
					>
						<span class="icon-[mdi--logout] mr-2" aria-hidden="true"></span>
						{m.logout()}
					</a>
				</li>
			</ul>
		</div>
	{/if}
</button>
